module.exports = __webpack_public_path__ + "img/smbc.810093b1.svg";